import { createReducer, on } from "@ngrx/store";
import { Tag } from "@prism/prism-shared";
import { SharedActions } from ".";

export interface SharedState {
    tags: Tag[]

    loadingState: number;
    error: any;
}

export const initialState: SharedState = {
    tags: [],

    loadingState: 0,
    error: null,
}

export const sharedReducer = createReducer(
    initialState,
    on(SharedActions.LoadTags.initial, (state): SharedState => ({
        ...state,
        loadingState: state.loadingState + 1,
        error: null,
    })),
    on(SharedActions.LoadTags.success, (state, { tags }): SharedState => ({
        ...state,
        loadingState: state.loadingState - 1,
        tags,
        error: null,
    })),
    on(SharedActions.LoadTags.failure, (state, { error }): SharedState => ({
        ...state,
        loadingState: state.loadingState - 1,
        error,
    }))
)